import axios from "../../config/axiosConfig";
import {
  DELIVERY_CHALLAN_REGISTER_YARN_REPORT_REQUEST,
  DELIVERY_CHALLAN_REGISTER_YARN_REPORT_SUCCESS,
  DELIVERY_CHALLAN_REGISTER_YARN_REPORT_FAILURE,
  DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_REQUEST,
  DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_SUCCESS,
  DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_FAILURE
} from "../types/delivery-challan-register-yarn-report-types";

export const getAllDeliveryChallanInvoiceNumberOfDeliveryChallanYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-register-report/getAllDeliveryChallanInvoiceNumberOfDeliveryChallanYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllAccountOfDeliveryChallanYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-register-report/getAllAccountOfDeliveryChallanYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllItemsOfDeliveryChallanYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-register-report/getAllItemsOfDeliveryChallanYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllVehiclesOfDeliveryChallanYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-register-report/getAllVehiclesOfDeliveryChallanYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllDeliveryAccountOfDeliveryChallanYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-register-report/getAllDeliveryAccountOfDeliveryChallanYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllAreaOfDeliveryChallanYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-register-report/getAllAreaOfDeliveryChallanYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllScheduleAreaOfDeliveryChallanYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-register-report/getAllScheduleAreaOfDeliveryChallanYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllInwardVehiclesOfDeliveryChallanYarn = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/delivery-challan-register-report/getAllInwardVehiclesOfDeliveryChallanYarn", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getDeliveryChallanRegisterYarnReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REGISTER_YARN_REPORT_REQUEST });
      console.log('ent1>>1121');


      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      
      // Merge default params with provided params
      const data = { ...defaultParams, ...defaultParams2 };
      // Construct the complete URL with query parameters
      // const queryString = new URLSearchParams(requestParams).toString();
      // const fullUrl = `/delivery-challan-register-report/yarn?${queryString}`;
      // Log the full URL (to debug)
      // console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.post('/delivery-challan-register-report/yarn', data, { params: defaultParams }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          console.log('ent1>>2221');

          dispatch({ type: DELIVERY_CHALLAN_REGISTER_YARN_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: DELIVERY_CHALLAN_REGISTER_YARN_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: DELIVERY_CHALLAN_REGISTER_YARN_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getDeliveryChallanRegisterYarnFilterDetail = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_REQUEST });
      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        commanMaster: auth?.company?.Common_Master,
      };
      const requestParams = { ...defaultParams };
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/delivery-challan-register-report/filter-detail/yarn?${queryString}`;
      console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching delivery challan Register Report:", error);
        dispatch({ type: DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching delivery challan Register Report:", error);
      dispatch({ type: DELIVERY_CHALLAN_REGISTER_YARN_FILTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearDeliveryChallanRegisterYarnReport = () => {
  return async (dispatch) => {
    dispatch({ type: DELIVERY_CHALLAN_REGISTER_YARN_REPORT_SUCCESS, payload: {} });
  }
}
